import React, { useState, useEffect } from "react";
import {
    Accordion, AccordionSummary, AccordionDetails,
    Typography, Grid, Box, TextField, IconButton, CircularProgress,
    Button
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import NakdanButton from "../../SharedArea/NakdanButton";

import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";

const ExistsOppositesSection = observer(() => {
    const existsInfo = additionalInfo.existsInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const [editedSentences, setEditedSentences] = useState({});

    useEffect(() => {
        if (existsInfo?.opposites) {
            setEditedSentences(
                existsInfo.opposites.reduce((acc, oppos) => {
                    acc[oppos._id] = oppos.text;
                    return acc;
                }, {})
            );
        }
    }, [existsInfo]);

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, opposites: !expanded.opposites });
    };

    const isHebrew = (text) => /^[\u0590-\u05FF]/.test(text.trim());

    return (
        <Grid item xs={12}>
            <Accordion
                expanded={expanded.opposites}
                onChange={() => handleToggle("opposites")}
                sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({existsInfo.opposites?.length || 0}) הפכים וזוגות</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%", textAlign: "center" }}>
                    {/* כפתור "מחק הכל" */}
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={() =>
                            additionalInfo.clearExistsInfoField(
                                existsInfo._id,
                                "opposites"
                            )
                        }
                        sx={{ mb: 2, ml: 1, minWidth: 81, minHeight: 36 }}
                        disabled={loading.updateExistsInfo.opposites?.clear}
                    >
                        {loading.updateExistsInfo.opposites?.clear ? (
                            <CircularProgress size={16} />
                        ) : (
                            "מחק הכל"
                        )}
                    </Button>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            justifyContent: "flex-start",
                            alignItems: "flex-start"
                        }}
                    >
                        {existsInfo.opposites?.length > 0 ? (
                            existsInfo.opposites.map((oppos) => {
                                const text = editedSentences[oppos._id] || "";

                                return (
                                    <Box
                                        key={oppos._id}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            bgcolor: "#f0f0f0",
                                            p: 1,
                                            borderRadius: 2,
                                            maxWidth: "210px",
                                            minWidth: "100px",
                                            flex: "1 0 auto"
                                        }}
                                    >
                                        <Box sx={{ display: "flex", gap: 0, ml: 1 }}>
                                            {/* כפתור ניקוד */}
                                            <NakdanButton
                                                text={text}
                                                onNikudComplete={(nikudText) => {
                                                    setEditedSentences(prev => ({
                                                        ...prev,
                                                        [oppos._id]: nikudText,
                                                    }));
                                                }}
                                            />
                                            {/* כפתור שמירה */}
                                            <IconButton
                                                onClick={() =>
                                                    additionalInfo.updateExistsInfo(
                                                        existsInfo._id,
                                                        "opposites",
                                                        oppos._id,
                                                        { text: editedSentences[oppos._id] }
                                                    )
                                                }
                                                disabled={loading.updateExistsInfo.opposites?.[oppos._id] === "text"}
                                            >
                                                {loading.updateExistsInfo.opposites?.[oppos._id] === "text"
                                                    ? <CircularProgress size={24} />
                                                    : <SaveIcon color="primary" />}
                                            </IconButton>
                                            {/* כפתור מחיקה */}
                                            <IconButton
                                                onClick={() =>
                                                    additionalInfo.deleteExistsInfo(
                                                        existsInfo._id,
                                                        "opposites",
                                                        oppos._id
                                                    )
                                                }
                                                disabled={loading.deleteExistsInfo.opposites?.[oppos._id]}
                                            >
                                                {loading.deleteExistsInfo.opposites?.[oppos._id]
                                                    ? <CircularProgress size={24} />
                                                    : <DeleteIcon color="error" />}
                                            </IconButton>
                                        </Box>
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            multiline
                                            minRows={1}
                                            value={text}
                                            onChange={(e) =>
                                                setEditedSentences({
                                                    ...editedSentences,
                                                    [oppos._id]: e.target.value,
                                                })
                                            }
                                            sx={{
                                                direction: isHebrew(text) ? "ltr" : "rtl",
                                                flexGrow: 1
                                            }}
                                        />
                                    </Box>
                                );
                            })
                        ) : (
                            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Typography variant="body2" color="textSecondary">אין מסיחים זמינים עבור אוריגינאל</Typography>
                            </Box>)}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default ExistsOppositesSection;
